/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react'
import Image from 'next/image'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { WidgetType } from '@enums/WidgetType'
import { MONTHLY_REWARD_CTA_TEXT, REWARD_CARD_PNG } from './constants'
import styles from './whatsappChallan.module.scss'

interface Props {
  regNo
  widgetType
  phone
  vehicleData
}

const MonthlyRewardCard: React.FC<Props> = ({ regNo, phone, vehicleData }) => (
  <div className={styles.cardWrapper}>
    <div className={styles.cardContent}>
      <Image src={REWARD_CARD_PNG} alt="Reward Icon" width={80} height={80} />

      <h2 className={styles.title}>Monthly reward unlocked</h2>
      <p className={styles.subtitle}>for checking your challans</p>
    </div>
    <button
      type="button"
      className={styles.buttonToApp}
      onClick={() =>
        onDownloadApp({
          regNo,
          widgetType: WidgetType.CHALLAN_WIDGET_LANDING,
          phone,
          vehicleData,
          ctaText: MONTHLY_REWARD_CTA_TEXT,
        })
      }>
      Claim reward on the app
    </button>
  </div>
)

export default MonthlyRewardCard
